import React from 'react';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';
import { AllPeople } from '../../components/people';

function Peoples (){
    return(        
        <body>
        <Navbar/>
        <hr className='hr-min'/>
        <AllPeople/>
        <Footer/>
        </body>
    )
}
export default Peoples;